import * as React from "react";
import Loader from 'react-loader-spinner'

export const LoadingIndicator: React.FunctionComponent = () => {

  return(
    <div style={{
      width: "100%",
      height: "100",
      display: "flex",
      justifyContent: "center",
      alignItems: "center"
    }}> 
      <Loader type="TailSpin" color="#800080" height="100" width="100" />
    </div>
  )
    
}